/* @flow */
import * as React from "react";

type Props = {
  disabled?: boolean,
  onOutsideClick?: (event: MouseEvent) => void,
  children?:
    | (({ innerRef: (node: ?HTMLElement) => void }) => React.Node)
    | React.Node
};

class ClickOutside extends React.Component<Props> {
  node: ?HTMLElement;

  hanleDocumentClick = (event: MouseEvent) => {
    if (
      !this.props.disabled &&
      this.node != null &&
      event.target instanceof Node &&
      !this.node.contains(event.target) &&
      event.target.closest(".js-click-outside-disable") === null &&
      typeof this.props.onOutsideClick === "function"
    ) {
      this.props.onOutsideClick(event);
    }
  };

  componentDidMount() {
    document.addEventListener("click", this.hanleDocumentClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.hanleDocumentClick, true);
  }

  render() {
    const { onOutsideClick, ...props } = this.props;

    if (typeof this.props.children === "function") {
      return this.props.children({
        innerRef: node => {
          this.node = node;
        }
      });
    }

    return (
      <div
        ref={node => {
          this.node = node;
        }}
        {...props}
      />
    );
  }
}

export default ClickOutside;



// WEBPACK FOOTER //
// ./src/components/common/ClickOutside.js